import React, {useContext} from 'react'
import {EditedContext} from '../../../../partials/Context';

function Rest() {
    const edited = useContext(EditedContext);
    const {changeBtn, edited_item, input_value, setInputValue, lawyer_data, setEditedItem} = edited || '';
    const {organizations, recommendations, notes} = lawyer_data || '';
  return (
    <div id="rest" className="top-buffer">
        <h1 className="title">Pozostałe</h1>
        <div className="rest-content">
            <div className="form-group">
                <div className="row">
                    <span className="form-title">Organizacje</span>
                    {changeBtn('organizations')}
                </div>
                    {edited_item === 'organizations' ?
                        <input type="text" className="form-input" value={input_value.organizations} onChange={(e)=>setInputValue({organizations: e.target.value})}/>
                        :
                        <span id="organizations" className="rest-value" onClick={() => {
                            setInputValue({organizations: organizations});
                            setEditedItem('organizations')
                        }}>{organizations ? organizations : '(przynależność do organizacji, w tym samorządowych, pełnione funkcje)'}</span>
                    }
                    
               
                <div className="row">
                    <span className="form-title">Rekomendacje</span>
                    {changeBtn('recommendations')}
                </div>
                 {edited_item === 'recommendations' ?
                        <input type="text" className="form-input" value={input_value.recommendations} onChange={(e)=>setInputValue({recommendations: e.target.value})}/>
                        :
                        <span id="recommendations" className="rest-value" onClick={() => {
                            setInputValue({recommendations: recommendations});
                            setEditedItem('recommendations')
                        }}>{recommendations ? recommendations : '(rekomendacje, których mogłyby udzielić wymienione firmy)'}</span>
                    }
                <div className="row">
                    <span className="form-title">Inne uwagi</span>
                    {changeBtn('notes')}
                </div>
                {edited_item === 'notes' ?
                        <input type="text" className="form-input" value={input_value.notes} onChange={(e)=>setInputValue({notes: e.target.value})}/>
                        :
                        <span id="notes" className="rest-value" onClick={() => {
                            setInputValue({notes: notes});
                            setEditedItem('notes')
                        }}>{notes ? notes : '(inne cechy lub wydarzenia dodatkowo opisujące prawnika (kancelarię), mogące mieć wpływ na klienta)'}</span>
                    }
            </div>
        </div>
    </div>
  )
}

export default Rest